<template>
  <div class="player-statistics" :class="isAnadoluEfes == true ? '' : 'opponent'">
    <table class="table">
      <thead>
        <tr>
          <th class="first-row"></th>
          <th>Süre</th>
          <th width="100">S</th>
          <th>&nbsp;&nbsp;2S&nbsp;&nbsp;</th>
          <th>&nbsp;&nbsp;3S&nbsp;&nbsp;</th>
          <th>&nbsp;&nbsp;SA&nbsp;&nbsp;</th>
          <th>OR</th>
          <th>DR</th>
          <th>R</th>
          <th>A</th>
          <th>TÇ</th>
          <th>TK</th>
          <th>B</th>
          <th>F</th>
          <th>YF</th>
          <th>VP</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data">
          <td class="first-row">
            <div class="row no-gutters player-row">
              <div class="col-5">
                <div class="position-relative">
                  <div class="player-image rounded-circle overflow-hidden blue-border">
                    <img
                      :src="isAnadoluEfes == true ? $store.state.baseImageURL + '/img/player/' + $store.state.app.yearslug + '/' + item.jerseyNo + '/face.webp' : '/static/img/user-avatar.svg'"
                      class="w-100"
                    />
                  </div>
                  <div class="player-number">{{item.jerseyNo}}</div>
                </div>
              </div>
              <div class="col-5">
                <div class="player-name">{{item.playerName}}</div>
              </div>
            </div>
          </td>
          <td>{{item.playTime}}</td>
          <td>{{item.score}}</td>
          <td>{{item.twoPoints}}</td>
          <td>{{item.threePoints}}</td>
          <td>{{item.freeThrowPoints}}</td>
          <td>{{item.offensiveRebounds}}</td>
          <td>{{item.defensiveRebounds}}</td>
          <td>{{item.totalRebounds}}</td>
          <td>{{item.assists}}</td>
          <td>{{item.steals}}</td>
          <td>{{item.turnovers}}</td>
          <td>{{item.blocks}}</td>
          <td>{{item.fouls}}</td>
          <td>{{item.foulsReceived}}</td>
          <td>{{item.effPoints}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "PlayerStatistics",
  props: ["title", "isAnadoluEfes", "data"],
  components: {},
  data() {
    return {};
  }
};
</script>

<style>
.opponent .first-row .player-row .player-number {
  background-color: #7a8fa6;
  text-align: center;
  line-height: 18px;
}

.player-statistics .first-row .player-row .player-number {
  text-align: center;
  line-height: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/PlayerStatistics.vue